import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";

const useAuthRedirect = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.access_token) {
      navigate("/dashboard");
    } 
  }, [user, navigate]);
};

export default useAuthRedirect;
